define.alias("shared/components/shared/pre-boarding/context-modal/bottom-plan-card", "settings/components/shared/pre-boarding/context-modal/bottom-plan-card");